import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCompass } = FiIcons;

function HomePage() {
  const [countdown, setCountdown] = useState(5);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          window.location.href = 'https://itskaivalya.com';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleGoNow = () => {
    window.location.href = 'https://itskaivalya.com';
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-2xl mx-auto text-center">
          {/* Compass Icon */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <div className="w-16 h-16 mx-auto mb-6 text-gray-400">
              <SafeIcon icon={FiCompass} className="w-full h-full" />
            </div>
          </motion.div>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold text-black mb-6 leading-tight"
          >
            You're in the right place — but this isn't the full story.
          </motion.h1>

          {/* Body Text */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed"
          >
            This is our landing page hub. For full details visit itskaivalya.com
          </motion.p>

          {/* Countdown */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mb-8"
            aria-live="polite"
          >
            <p className="text-base text-gray-500">
              Redirecting you in{' '}
              <span className="font-semibold text-gray-900">{countdown}</span>{' '}
              seconds…
            </p>
          </motion.div>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <button
              onClick={handleGoNow}
              className="inline-flex items-center gap-2 bg-black hover:bg-gray-800 focus:bg-gray-800 text-white font-semibold px-8 py-4 rounded-lg text-lg transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-gray-300 min-h-[44px]"
              aria-label="Go to main site now"
            >
              Go now
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </button>
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-6 border-t border-gray-100">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-sm text-gray-500">
            © {currentYear} ItsKaivalya. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;